import Vue from "vue";
import Vuetify from "vuetify";
import "vuetify/dist/vuetify.min.css";
import pt from "vuetify/es5/locale/pt";

Vue.use(Vuetify);

const opts = {
    lang: {
        locales: { pt },
        current: "pt"
    },
    theme: {
        themes: {
            light: {
                primary: "#2D5071",
                secondary: "#21acd5",
                accent: "#8c9eff",
                error: "#FF2B00",
                warning: "#FFBE26",
                ropo: "#CFDBE6"
            },
            dark: {
                primary: "#2D5071",
                secondary: "#21acd5",
                accent: "#8c9eff",
                error: "#FF2B00",
                warning: "#FFBE26",
                ropo: "#CFDBE6"
            }
        }
    }
};

export default new Vuetify(opts);
